<template>
  <div id="video-container-wrapper">
    <div id="video-container">
    </div>
    <div id="video-label-container" v-if="videoLabel && videoUrl">
      <p class="label">{{ videoLabel }}</p>
      <p class="button">{{ $t('videoLabel.button') }} <a v-on:click="clickedVideoLink" :href="videoLinkUrl" target="_blank">{{ $t('videoLabel.link') }}</a></p>
    </div>
    <div id="video-container-overlay" v-show="videoOverlayActivated" @mousedown="disableOverlay">
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState, mapGetters, mapActions } from 'vuex';
import { jStreamEvents } from '@/utils/constants';
import { getParentSiteUrl } from '@/utils/urlHelper';
export default {
  computed: {
    ...mapState(['lessonId', 'studentRank', 'lessonBookRank', 'programId']),
    ...mapState('material', ['currentLesson', 'currentRank', 'rankTotal']),
    ...mapState('video', ['videoId', 'isVideoReady', 'activate', 'videoLabel', 'videoUrl', 'videoLog']),
    ...mapState('layout', ['videoOverlayActivated']),
    ...mapState('userOtherSetting', ['countryId']),
    ...mapGetters(['isToEnableVideoLesson']),
    
    videoLinkUrl() {
      const parentSiteUrl = getParentSiteUrl(this.countryId);
      return parentSiteUrl + this.videoUrl;
    }
  },

  watch: {
    videoId(newVal) {
      if (newVal && this.isToEnableVideoLesson) {
        this.createJstreamPlayer();
      }
    }
  },

  methods: {
      ...mapMutations('video', ['setVideoReady', 'setActivate']),
      ...mapMutations('layout', ['setVideoOverlayActivated']),
      ...mapActions('video', ['toggleVideoLesson', 'resetVideoSetting']),
      disableOverlay() {
        this.setVideoOverlayActivated(false);
      },
      createJstreamPlayer() {
          let vm = this;
          this.toggleVideoLesson(true);
          if (!vm.isVideoReady && vm.activate) {
            return;
          }

          vm.setVideoReady(false);
          try {
            this.setActivate(true);
            window.player = window.jstream_t3.PlayerFactoryIF.create({
              b: "eqa899tizf.eq.webcdn.stream.ne.jp/www50/eqa899tizf/jmc_pub/jmc_swf/player/",
              c: "MTI3NA==",
              m: vm.videoId,
              s: {
                  el:"off",
                  il:"off",
                  rb:"off",
                  sn:"",
                  tg:"off",
                  rp: 'fit',
                  wp: 728,
                  hp: 400,
                  pr:"0.75,1.25,1.5,1.75,2.0"
              },
            }, 'video-container');
            
            window.player.accessor.addEventListener('landing', function() {
              vm.setVideoReady(true);
              vm.$logger.info('Video lesson successfully loaded', {
                operation: 'video-lesson',
                video_event: jStreamEvents.landing,
                video_id: vm.videoId,
                ...vm.videoLog
              });
            });

            window.player.accessor.addEventListener("change_state", function (event) {
              if (event.currentTarget && jStreamEvents.playing === event.currentTarget.state) {
                vm.$logger.info('User played video lesson', {
                  operation: 'video-lesson',
                  video_event: jStreamEvents.playing,
                  video_id: vm.videoId,
                  ...vm.videoLog
                });
              }
            });

          } catch (err) {
            vm.resetVideoSetting();
          }
      },
      clickedVideoLink() {
        this.$logger.info('User clicked on the video lesson link', {
          operation: 'video-lesson',
          video_event: jStreamEvents.clicked,
          video_id: this.videoId,
          ...this.videoLog
        });
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped src="@/assets/css/pc/video_lesson.css"></style>
